import ContentPage from "../../Content";

function EvdPosPage(){
    return (
        <>
            <ContentPage>
                
            </ContentPage>
        </>
    )
}
export default EvdPosPage;